export default __webpack_public_path__ + "static/media/WhiteClockIcon.2563b571.svg";